import { render, staticRenderFns } from "./ProfileCardGovernment.vue?vue&type=template&id=a507c4f0&"
import script from "./ProfileCardGovernment.vue?vue&type=script&lang=js&"
export * from "./ProfileCardGovernment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports